import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
import { AppContext } from '../../AppProvider';

import { formatAddress } from '../../utils/Shipment';
import { midnightSecondsToHour } from '../../utils/DateTime';
import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import ButtonStyles from '../../styles/button';
import TypographyStyles from '../../styles/typography';
import SpacingStyles from '../../styles/helpers/spacing';
import FormItemContainer from './../Global/Containers/FormItemContainer';
import CollapseWrapper from './../Global/CollapseWrapper';

const styles = theme => ({
  notesContainer: {
    backgroundColor: '#F2FAFF',
    padding: theme.spacing.unit * 2
  },
  note: {
    borderTop: '1px solid rgba(0,0,0,0.12)',
    paddingTop: theme.spacing.unit * 2
  },
  noteBody: {
    marginTop: [theme.spacing.unit, '!important']
  },
  buttonColor: {
    color: `${theme.palette.primary.main} !important`,
    top: '-10px'
  },
  noteTitle: {
    color: '#00A1FB',
    fontFamily: theme.typography.font.main,
    fontSize: '14px',
    fontWeight: '500',
    letterSpacing: '0.13px',
    lineHeight: '20px',
    margin: 0
  },
  heading: { marginBottom: [theme.spacing.unit * 0.5, '!important'] },
  pickupNotes: {
    paddingBottom: '0 !important'
  }
});

export class Details extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired
  };
  editButton = () => {
    const { classes, t, location, history } = this.props;
    return (
      <Button
        className={classnames(classes.button, classes.editButton)}
        onClick={() => {
          history.push(`/locations/${location.id}/edit`);
        }}
        color={'primary'}
        variant={'text'}
        disableRipple={true}
        classes={{
          label: classes.buttonLabelSecondaryAction,
          root: classes.buttonRoot
        }}
      >
        {t('Edit')}
      </Button>
    );
  };
  render() {
    const { t, classes, location } = this.props;
    const {
      orgInfo: { config }
    } = this.context.globalProps;
    const orgDefaultDockOpenTime = _get(config, 'defaultDockOpenTime', null);
    const orgDefaultDockCloseTime = _get(config, 'defaultDockCloseTime', null);

    const resolvedDockOpenTime =
      location.openFromTimeLocal || orgDefaultDockOpenTime;
    const resolvedDockCloseTime =
      location.openToTimeLocal || orgDefaultDockCloseTime;

    return (
      <Fragment>
        <FormItemContainer
          title={t('Location Details')}
          secondaryAction={this.editButton()}
        >
          <Grid container spacing={16}>
            <Grid item lg={3}>
              <p className={classnames(classes.subtitle2, classes.heading)}>
                {t('Address')}
              </p>
              <p className={classes.body2}>
                {_get(location, 'address.address1')}
              </p>
              <p className={classes.body2}>{formatAddress(location.address)}</p>
            </Grid>
            <Grid item lg={3}>
              <p className={classnames(classes.subtitle2, classes.heading)}>
                {t('Location Name')}
              </p>
              <p className={classes.body2}>{location.name || ''}</p>
            </Grid>
            <Grid item lg={3}>
              <p className={classnames(classes.subtitle2, classes.heading)}>
                {t('External ID')}
              </p>
              <p className={classes.body2}>{location.externalId || ''}</p>
            </Grid>
            <Grid item lg={3}>
              <p className={classnames(classes.subtitle2, classes.heading)}>
                {t('Dock Times')}
              </p>
              <p className={classes.body2}>{`${midnightSecondsToHour(
                resolvedDockOpenTime,
                { displayMinutes: true }
              )} - ${midnightSecondsToHour(resolvedDockCloseTime, {
                displayMinutes: true
              })}`}</p>
            </Grid>
            <Grid item lg={12} classes={{ item: classes.pickupNotes }}>
              <CollapseWrapper
                classes={{
                  root: classes.notesContainer,
                  bodyRoot: classes.noteBody,
                  expandButton: classes.buttonColor
                }}
                header={
                  <div className={classes.titleWrapper}>
                    <h2 className={classes.noteTitle}>{t('Pickup notes')}</h2>
                  </div>
                }
                body={
                  <div className={classes.note}>
                    <p className={classes.body2Light}>
                      {location.pickupNotes || 'N/A'}
                    </p>
                  </div>
                }
              />
            </Grid>
            <Grid item lg={12}>
              <CollapseWrapper
                classes={{
                  root: classes.notesContainer,
                  bodyRoot: classes.noteBody,
                  expandButton: classes.buttonColor
                }}
                header={
                  <div className={classes.titleWrapper}>
                    <h2 className={classes.noteTitle}>{t('Delivery notes')}</h2>
                  </div>
                }
                body={
                  <div className={classes.note}>
                    <p className={classes.body2Light}>
                      {location.deliveryNotes || 'N/A'}
                    </p>
                  </div>
                }
              />
            </Grid>
          </Grid>
        </FormItemContainer>
      </Fragment>
    );
  }
}

Details.contextType = AppContext;
export default withStyles(
  combineStyles(
    styles,
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles
  )
)(withNamespaces()(Details));
